import { ContainerProps } from "react-bootstrap";
import ErrorConstants from "../../shared/constants/errors.constants";
import { Errors } from "../../shared/enums/errors.enums";
import { ErrorCodeDetails } from "../../shared/types/error.types";
import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface INoResultsProps extends ContainerProps {
  isSearch: boolean;
}

export const DefaultTemplateProps = {
  isSearch: false,
};

export interface IErrorPageProps extends ITestableComponentProps {
  error: ErrorCodeDetails;
}

export const DefaultErrorPageProps: IErrorPageProps = {
  error: ErrorConstants[Errors.UNKNOWN_ERROR],
};
